import { render, staticRenderFns } from "./MmDeliveryDetailList.vue?vue&type=template&id=9e59992e&"
import script from "./MmDeliveryDetailList.vue?vue&type=script&lang=js&"
export * from "./MmDeliveryDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports